<template>
  <div>
    <div class="index_top_image">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="item in imgArray">
          <img :src="item" class="rightImg">
        </el-carousel-item>
      </el-carousel>
      <div class="top_image_nav">
        <img src="../../assets/image/leBaiBaiImg/leLogoTwo.png" class="small_image">
        <span class="title_span">热摆摆网络科技</span>
        <div class="tab_box">
          <el-tabs v-model="activeName1" @tab-click="handleClick1">
            <el-tab-pane label="首页" name="/reBaiBai"></el-tab-pane>
            <el-tab-pane label="关于我们" name="reBaiAbout"></el-tab-pane>
            <el-tab-pane label="APP入驻" name="APP入驻" ></el-tab-pane>
            <el-tab-pane label="云游戏" name="云游戏"></el-tab-pane>
            <el-tab-pane label="微信小游戏" name="微信小游戏"></el-tab-pane>
            <el-tab-pane label="APP中心" name="APP中心"></el-tab-pane>
            <el-tab-pane label="开放平台" name="开放平台"></el-tab-pane>
          </el-tabs>
        </div>
      </div>

    </div>
    <div class="index_tow_box" id="companyProduct">
      <!--      1-->
      <div  v-if="activeIndex==2">
        <img src="../../assets/image/leBaiBaiImg/riceDogLogo.jpg" class="logo_one_image"/>
        <span class="logo_title_span">兼职檽米狗</span>
        <span class="logo_span_one">
做兼职，上兼职檽米狗，职位多，赚钱快！临时工、实习、赚钱、在家兼职，网上兼职、找工作这里应有尽有！兼职檽米狗是一款能够让你轻松兼职的网络兼职手机应用。满足在校大学生，居家宝妈和上班族利用空闲时间赚钱的兼职需求，众多名气直聘的兼职岗位，并提供满意可靠服务的互联网兼职的垂直平台。以众多优质兼职资源为依托，为兼职者提供人性化，个性化，专业化的兼职信息服务，让兼职者和优秀企业都能及时解决个人所需达成合作，让每一次兼职变得更便捷，更愉悦！
         <span class="copyright_span">版权所有：厦门乐榜网络科技有限公司</span>
        </span>
        <button class="download_app_btn" @click="toDownload1('http://apk.hotbuybuy.com/nmg_meizu_155_236_jiagu_sign.apk')">下载app</button>
        <img src="../../assets/image/leBaiBaiImg/riceDogOne.png" style="margin-left: 20rem;margin-top: -8rem;width: 202px;height: auto"/>
        <img src="../../assets/image/leBaiBaiImg/riceDogTwo.png" style="margin-top: -20.5rem;width: 316px;height: 557px;">
      </div>
      <!--      2-->
      <div  v-if="activeIndex==1">
        <img src="../../assets/image/leBaiBaiImg/timeDiaryLogo.png" class="logo_one_image"/>
        <span class="logo_title_span">时光日记本</span>
        <span class="logo_span_one">
           「受欢迎的日记应用，超高颜值，专为500万人精心打造」<br/>
          「隐私、安全、简单、精致、功能强大、越用越喜欢」<br/>
          「日记、记事、笔记、便签、备忘录都能够满足你！」
           <span class="copyright_span">版权所有：上海藤玩网络科技有限公司</span>
        </span>
        <button class="download_app_btn"  @click="toDownload1('http://apk.hotbuybuy.com/nootbook_qh360_v2.4.8_release_248_jiagu_sign.apk')">下载app</button>
        <img src="../../assets/image/leBaiBaiImg/timeDiaryOne.png" style="margin-left: 20rem;margin-top: -8rem;width: 202px;height: auto"/>
        <img src="../../assets/image/leBaiBaiImg/timeDiaryTwo.png" style="margin-top: -20.5rem;width: 316px;height: 557px;">
      </div>
      <!--      3-->
      <div v-if="activeIndex==0">
        <img src="../../assets/image/leBaiBaiImg/lemonLogo.png" class="logo_one_image"/>
        <span class="logo_title_span">有檬兼职</span>
        <span class="logo_span_one">
          手机赚钱就选有檬兼职<br/>
          有檬 兼职 是一款让你做任务，轻松.赚.的APP。玩手机兼职做赚钱任务，轻松赚到生活费，有檬兼职，帮你找到新的生活方式。丰富的任务类型和海量任务，就在有檬兼职。<br/>
          【新手任务赚】<br/>
          新手任务专为新人定制，有檬兼职传授任务秘笈，帮你轻松赚取第一桶金。<br/>
          【任务体验赚】<br/>
          有檬兼职为你优选兼职任务，边体验边赚钱，乐趣多多钱多多。<br/>
           <span class="copyright_span">版权所有：上海峙莹网络科技有限公司</span>
        </span>
        <button class="download_app_btn" @click="toDownload1('http://apk.hotbuybuy.com/youmeng_xy_125_125_jiagu_sign.apk')">下载app</button>
        <img src="../../assets/image/leBaiBaiImg/lemonOne.png" style="margin-left: 20rem;margin-top: -8rem;width: 202px;height: auto"/>
        <img src="../../assets/image/leBaiBaiImg/lemonTwo.png" style="margin-top: -20.5rem;width: 316px;height: 557px;">
      </div>
      <div  class="logo_img_box" style="margin-top: 7.5rem;margin-left: 9rem;">
        <div v-for="(item,index) in logoarr" :key="index" style="width: 60px;height: 60px; position: relative;margin-top: 5rem;overflow: hidden; border-radius: 50%;">
          <img :src="item" alt="" style="width: 100%;height: 100%;">
          <div @click="mouseover(index)"  :class=" index == activeIndex ? 'mask' : 'beforeMask' " style=""></div>
        </div>

      </div>
    </div>
    <div class="index_three_box" id="recuirtService">
      <div class="blue_word_box">
        <img src="../../assets/image/index1/Group2.png" style="margin-top: -3rem"/>
        <div class="small_box_one">
          <div class="this_one_box">
            <div v-show="oneshow"  @mouseenter="touchDiv" @mouseout="touchDiv2">
              <div style="width: 23.75rem;height: 12rem;background-color: rgb(244,246,251);" >
                <img src="../../assets/image/index1/hot.png" style="margin-top: 2rem">
              </div>
              <span class="tow_span">热门精选岗位名企信誉保障</span>
            </div>

          </div>
          <div v-show="onehide"  @mouseenter="touchDiv" @mouseout="touchDiv2">
            <img src="../../assets/image/index1/hot.png" class="small_one_image" style="width: 5rem;height: 5rem;float: left;margin-top: 1.5rem;margin-left: 9.4rem;"/>
            <span class="recruit_span_box">将您的职位添加到热门精选岗位，展示位置更明显，曝光率更多在更短时间内招到应聘者，精选岗位展示</span>
            <span class="one_span">人才有保障，省时更省力</span>
          </div>

        </div>
        <div class="small_box_tow">
          <div v-show="towshow" @mouseenter="touchDiv3" @mouseout="touchDiv4">
            <div style="width: 23.75rem;height: 12rem;background-color: rgb(244,246,251);">
              <img src="../../assets/image/index1/bianZu10.png" style="margin-top: 2rem">
            </div>
            <span class="tow_span">职位要求限制找到更合适的人</span>
          </div>
          <div @mouseenter="touchDiv3" @mouseout="touchDiv4" v-show="towhide">
            <img src="../../assets/image/index1/bianZu10.png" class="small_one_image" style="width: 5rem;height: 5rem;float: left;margin-top: 1.5rem;margin-left: 9.4rem;"/>
            <span class="recruit_span_box">在发布岗位时，您可以添加包括性别、地区、学历等限制条件，不符合要求的用户将看不到你的职位信息</span>
            <span class="one_span">更精准得寻找合适得人才</span>
          </div>
        </div>
        <div class="small_box_three" >
          <div v-show="threeshow" @mouseenter="touchDiv5" @mouseout="touchDiv6">
            <div style="width: 23.75rem;height: 12rem;background-color: rgb(244,246,251);">
              <img src="../../assets/image/index1/bianZu11.png" style="margin-top: 2rem">
            </div>
            <span class="tow_span">在线及时沟通不错过每一个人才</span>
          </div>
          <div v-show="threehide" @mouseenter="touchDiv5" @mouseout="touchDiv6">
            <img src="../../assets/image/index1/bianZu11.png" class="small_one_image" style="width: 5rem;height: 5rem;float: left;margin-top: 1.5rem;margin-left: 9.4rem;"/>
            <span class="recruit_span_box">应聘者报名后可立即与您发起沟通，与此同时，您将会收到短信或邮件提现，立即通过我们的平台与应聘者交流</span>
            <span class="one_span">不错过每一个人才</span>
          </div>

        </div>
      </div>
      <button class="start_recurit_btn" @click="toLogin()">开始招聘</button>
    </div>
    <div class="index_four_box" id="ourPhilosophy">
      <img src="../../assets/image/index1/Group10.png" style="margin-left: 23.9rem;margin-top: 6rem;"/>
      <img src="../../assets/image/index1/bianZu2.png" style="margin-left: 22.5rem;margin-top: 0.6rem"/>
      <span class="more_word_span">诚信是市场经济的基础；诚信是企业发展和做人的根本。合作是为了共同的目的一起工作或共同完成某项任务。共赢与发展是在共同的价值理念下，共同承担风险，共同分享利益，达至共同目标，共同获得持续发展。共赢能提升企业竞争力，规范行业标准，有效配置各种社会资源，它是智慧、实力、品牌和人力资源的强强联手，是企业与客户、与战略伙伴、与员工的相互依存、共同发展的支撑点。然而，共赢不可能自然而然地实现，它首先要有信念、意志和品格等主观品质基础。企业在寻求自己利益的同时，也要主动考虑别人的利益，以互利、互信、互赖、合作代替独立竞争。</span>
    </div>
    <div class="index_bottom_box">
      <img src="../../assets/image/leBaiBaiImg/leLogoTwo.png" style="width:110px;height:110px;margin-top: 11rem;margin-left: 28.5rem;border-radius: 8px"/>
      <span class="bottom_company_name">厦门热摆摆网络科技有限公司</span>
      <span class="shou_ye">首页</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 54.2rem;color: #FFFFFF">|</span>
      <span class="qi_ye">企业服务</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 64.6rem;color: #FFFFFF">|</span>
      <span class="guan_yu">关于我们</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 74.6rem;color: #FFFFFF">|</span>
      <span class="guan_yu" style="margin-left: 77.8rem">联系我们</span>
      <ul>
        <li style="color: #8E9DC3;width: 4.3rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/reBaiBai#companyProduct" style="color: #333333;">旗下产品</a></li>
        <li style="color: #8E9DC3;width: 4.3rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/reBaiBai#recuirtService" style="color: #333333;">招聘服务</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/reBaiBai#ourPhilosophy" style="color: #333333;">我们的理念</a></li>
      </ul>
      <ul>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 57.85rem;margin-top: -7.2rem;list-style: none"><a style="color: #333333;" href="/reBusiness#qualityService">优质服务</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 57.85rem;margin-top: 1.8rem;list-style: none"><a style="color:#333333;" href="/reBusiness#merchantsMove">商家入驻</a></li>
      </ul>
      <ul>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: -4.2REM;list-style: none"><a style="color: #333333;" href="/reBaiAbout#companyProfile">公司简介</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: 1.8rem;list-style: none"><a style="color:#333333;" href="/reBaiAbout#contanctUs">联系我们</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: 1.8rem;list-style: none"><a style="color: #333333;" href="/reBaiAbout#moreQuestion">常见问题</a></li>
      </ul>
      <ul>

        <li style="color: #333333;width: 9.8rem;height: 1.25rem;margin-left: 77.85rem;margin-top: -4.2rem;list-style: none">商务合作邮箱：3348759773@qq.com</li>
        <li style="color: #333333;width: 9.8rem;height: 1.25rem;margin-left: 77.85rem;margin-top: -4.2rem;list-style: none">客服热线：&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp 0592-5535810</li>
      </ul>
      <div class="bottom_bg">
        <span class="bottom_bg_span">© 2021 厦门口热摆摆网络科技有限公司. 版权所有</span>
        <a class="bottom_bg_a" href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #333333">闽ICP备18019105号-3</a>
      </div>
    </div>
  </div>
</template>

<script>
const urls = require('../../../url');
export default {
  name: "leBaiBaiIndex",
  data(){
    return{
      activeName1: '/reBaiBai',
      one:false,
      tow:false,
      activeIndex:0,
      myInterval:'',
      imgArray: [
        require('../../assets/image/index1/banner2.png'),
        require('../../assets/image/index1/banner.png')
      ],
      logoarr:[
        require('../../assets/image/leBaiBaiImg/lemonLogo.png'),
        require('../../assets/image/leBaiBaiImg/timeDiaryLogo.png'),
        require('../../assets/image/leBaiBaiImg/riceDogLogo.jpg'),
      ],
      onehide:false,
      oneshow:true,
      towhide:false,
      towshow:true,
      threehide:false,
      threeshow:true,
    }
  },
  methods:{
    banner(){
      setTimeout(()=>{
        if(this.activeIndex==2){
          this.activeIndex=0;
        }else {
          this.activeIndex++
        }
      },3000)
    },
    mouseover(val){
      clearInterval(this.myInterval);
      this.myInterval='';
      // console.log(this.myInterval)
      this.activeIndex=val;
      this.myInterval=setInterval(()=>{
        this.banner();
      },3000)
    },
    mouseout(){
      this.myInterval=setInterval(()=>{
        this.banner();
      },3000)
    },
    toLogin(){
      window.location.href=urls.loginUrl;
    },
    touchDiv(){
      this.onehide=true;
      this.oneshow=false
    },
    touchDiv2(){
      this.oneshow=true;
      this.onehide=false;
    },
    touchDiv3(){
      this.towshow=false;
      this.towhide=true;
    },
    touchDiv4(){
      this.towshow=true;
      this.towhide=false;
    },
    touchDiv5(){
      this.threeshow=false;
      this.threehide=true;
    },
    touchDiv6(){
      this.threeshow=true;
      this.threehide=false;
    },
    handleClick1(tab) {
      if(tab.paneName==='reBaiAbout'){
        this.$router.push(tab.paneName)
      }else{
        this.activeName1 = tab.paneName
      }
    },
    toDownload1(website){
      window.location.href=website;
    }
  },
  created() {
    this.myInterval= setInterval(
      ()=>{
        this.banner();
      },3000);
  }
}
</script>

<style scoped>
*{
  padding: 0;
  margin: 0;
  border:0;
}
.top_image_nav{
  position: absolute;
  width: 85%;
  height: 5rem;
  top: 5rem;
  left: 8.125rem;
}

.small_image {
  width: 40px;
  height: 40px;
  display: block;
  margin-left: 0.1rem;
  margin-top: 1.1rem;
  border-radius: 5px;
}

.title_span {
  color: white;
  font-size: 28px;
  display: block;
  margin-left: 56px;
  margin-top: -41px;
}
.index_top_image{
  width: 100%;
  height: 906px;
  background-color: rgb(237,240,246);
  background-image: url("../../assets/image/leBaiBaiImg/reBaiTop.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.rightImg {
  width: 100%;
  height: 906px;
  position: absolute;
  margin-top: -20px;
}

.index_tow_box{
  width: 100%;
  height: 50rem;
  background-color: rgb(237,240,246);
  display: flex;
  justify-content: flex-start;
}

.tab_box{
  width: 41%;
  height: 100px;
  margin-left: 1098px;
  margin-top: -28px;
}
.beforeMask{
  position: absolute;
  width: 100%;
  height: 100%;
  top:0;
  left: 0;
  background-color: rgba(0,0,0,.2);
  border-radius: 50%
}
.mask{
  position: absolute;
  width: 100%;
  height: 100%;
  top:0;
  left: 0;
  border-radius: 50%;
  background-color: rgba(0,0,0,0);
}
.logo_one_image{
  width: 120px;
  height: 120px;
  margin-left: 22.5rem;
  margin-top: 9rem;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.logo_title_span{
  font-size: 1.75rem;
  color: #333333;
  display: block;
  margin-left: 22.5rem;
  margin-top: 1.75rem;
}
.logo_span_one{
  width: 28.7rem;
  height: 7.25rem;
  display: block;
  font-size: 16px;
  color: #333333;
  margin-left: 22.5rem;
  margin-top: 1rem;
}
.download_app_btn{
  width: 11.25rem;
  height: 3.75rem;
  border-radius: 1.8rem;
  background-color: rgb(208, 85, 48);
  color: white;
  border: none;
  float: left;
  margin-left: 22.5rem;
  margin-top: 9rem;
}
.copyright_span{
  width: 22.25rem;
  margin-top: 5px;
  display: block;
}
.index_three_box{
  width: 100%;
  height: 43rem;
  background-color: rgb(240,242,245);
  position: relative;
}
.blue_word_box{
  width: 100%;
  height: 23.75rem;
  /*background-color: rgb(35,69,182);*/
  background-color: rgb(242, 94, 56);
  text-align: center;
  display: inline-block;
}
.middle_box_word{
  font-size: 2.5rem;
  color: #FFFFFF;
  display: inline-block;
  margin-top: 6rem;
}
.small_box_one{
  width: 23.75rem;
  height: 20rem;
  background-color: #FFFFFF;
  margin-left: 22.5rem;
  margin-top: -0.25rem;
}
.small_box_tow{
  width: 23.75rem;
  height: 20rem;
  background-color: #FFFFFF;
  margin-left: 48.1rem;
  margin-top: -20rem;
}
.small_box_three{
  width: 23.75rem;
  height: 20rem;
  background-color: #FFFFFF;
  margin-left: 73.75rem;
  margin-top: -20rem;
}
small_one_image{
  margin-top: -2rem;
}
.recruit_span_box{
  width: 14.3rem;
  height: 6.25rem;
  display: inline-block;
  font-size: 1rem;
  color: #333333;
  margin-top:1rem;
}
.one_span{
  width: 14.3rem;
  height: 1rem;
  font-size: 1rem;
  color: #333333;
  display: inline-block;
  margin-top: 1rem;
  font-weight: 600;
}
.tow_span{
  width: 10.5rem;
  height: 4rem;
  font-size: 1.5rem;
  color: #333333;
  display: inline-block;
  margin-top: 1.3rem;
}
.start_recurit_btn{
  width: 22.5rem;
  height: 3.75rem;
  border-radius: 1.8rem;
  background-color: rgb(208, 85, 48);
  color: #FFFFFF;
  border: none;
  position: absolute;
  top: 40rem;
  left: 48.5rem;
}
.index_four_box{
  width: 100%;
  height: 37.5rem;
  background-color: rgb(240,242,245);
}
.more_word_span{
  width: 38.5rem;
  height: 14.3rem;
  display: block;
  font-size: 1rem;
  margin-left: 59rem;
  margin-top: -15.5rem
}
.index_bottom_box{
  width: 100%;
  height: 31.75rem;
  background-color: rgb(240,242,245);
  background-image: url("../../assets/image/leBaiBaiImg/reBaiBottom.png");
  background-repeat: no-repeat;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.bottom_company_name{
  color: #FFFFFF;
  font-size: 1rem;
  display: block;
  margin-left: 25rem;
  margin-top: 1.5rem;
}
.shou_ye{
  font-size: 1rem;
  color: white;
  display: block;
  margin-left: 47.8rem;
  margin-top: -10rem;
}
.qi_ye{
  font-size: 1rem;
  color: #FFFFFF;
  display: block;
  margin-left: 57.8rem;
  margin-top: -1rem;
}
.guan_yu{
  font-size: 1rem;
  color: #FFFFFF;
  display: block;
  margin-left: 67.8rem;
  margin-top: -1rem;
}
.bottom_bg{
  width: 100%;
  height: 4.3rem;
  background-color: rgb(222, 91, 50);
  margin-top: 10rem;
}
.bottom_bg_span{
  width: 17rem;
  height: 2.75rem;
  display: inline-block;
  font-size: 0.75rem;
  text-align: center;
  /*color: #8E9DC3;*/
  color: #333333;
  margin-top: 0.75rem;
  margin-left: 51.6rem;
}
.bottom_bg_a{
  width: 17rem;
  height: 2.75rem;
  font-size: 0.75rem;
  /*color: #8E9DC3;*/
  color: #333333;
  text-align: center;
  display: block;
  margin-left: 52rem;
  margin-top: -1rem;
}

</style>
<style>
/*轮播显示的大小*/
.el-carousel__container {
  position: relative!important;
  height: 900px!important;
}

/*去掉标签页下划线*/
.el-tabs__nav-wrap:after {
  background-color: transparent!important;
}
/*修改轮播图指示器的位置*/
.el-carousel__indicators {
  position: absolute!important;
  top: 47.6rem!important;
}
/*修改线的位置*/
.el-tabs__active-bar {
  bottom: 0.45rem!important;
}
/*修改标签颜色*/
.el-tabs__item.is-active {
  color: white!important;
}
.el-tabs__item {
  color: white!important;
}
/*删除左右的箭头*/
.el-carousel__arrow--left {
  left: 16px!important;
  display: none!important;
}
.el-carousel__arrow--right {
  left: 16px!important;
  display: none!important;
}

</style>



// WEBPACK FOOTER //
// src/components/reBaiBai/leBaiBaiIndex.vue